import React from 'react';
import PropTypes from 'prop-types';
import {
    List,
    Paper,
    Subheader,
    Checkbox,
    TextField,
    Divider, FloatingActionButton,
} from 'material-ui';
import AddAPhotoIcon from 'material-ui/svg-icons/image/add-a-photo';
import Dropzone from 'react-dropzone';
import SendIcon from 'material-ui/svg-icons/content/send';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import style from '../../../styles/styles';
import withTranslation from '../../../hoc/withTranslation';
import Error from '../../common/Error/Error';
import ModuleService from '../../../services/module';
import ReportTalkMessage from './ReportTalkMessage';
import { blue600 } from 'material-ui/styles/colors';

const dialogStyle = {
    dialogBlockImg: {
        maxWidth: '100%',
        maxHeight: '24em',
    },
    textfield: {
        padding: 0,
        display: 'inline-block',
        width: 'calc(100% - 56px)',
    },
    dropzone: {
        maxWidth: 'calc(100% - 30px)',
        position: 'relative',
        textAlign: 'center',
        border: '1px dashed black',
        borderRadius: '10px',
        padding: '10px',
        marginLeft: '15px',
        marginRight: '15px',
    },
    list: {
        maxHeight: '628px',
        padding: 0,
        overflowX: 'hidden',
        overflowY: 'auto',
    },
    floatingButton: {},
    closeButton: {
        position: 'absolute',
        top: '15px',
        right: '15px',
        backgroundColor: '#FFF',
        color: '#000',
        borderRadius: '50%',
        width: '1.5em',
        height: '1.5em',
        border: 'none',
        cursor: 'pointer',
        padding: '4px 0',
    },
    closeButtonIcon: {
        position: 'relative',
        height: '100%',
        width: '100%',
    },
};

const supportedDropFiles = 'image/jpeg, image/png';

const DEFAULT_STATE = {
    value: '',
    push_entity: false,
    uploadingFile: null,
    uploadingFileUrl: '',
};

class ReportTalk extends React.Component {
    static propTypes = {
        report: PropTypes.object.isRequired,
        items: PropTypes.arrayOf(PropTypes.object),
        onClickAnswer: PropTypes.func.isRequired,
        authUsername: PropTypes.string.isRequired,
        state: PropTypes.string.isRequired,
        app: PropTypes.object.isRequired,
    };

    static defaultProps = {
        items: [],
    };

    constructor(props) {
        super(props);
        this.state = DEFAULT_STATE;
    }

    componentDidMount() {
        setTimeout(() => {
            const container = document.querySelector('#talk');
            container.scrollTop = container.scrollHeight;
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.items.length !== this.props.items.length) {
            setTimeout(() => {
                const container = document.querySelector('#talk');
                container.scrollTop = container.scrollHeight;
            }, 300);
        }
    }

    handleChange = (event) => {
        this.setState({
            value: event.target.value,
        });
    };

    handlePushChange = (event) => {
        let newState = !this.state.push_entity;
        this.setState({
            push_entity: newState,
        });
    };

    handleSendNewItem = (event) => {
        if (this.state.value !== '') {
            this.props.onClickAnswer(this.state.value,
                this.state.uploadingFile,
                this.state.push_entity,
            );
            this.setState(DEFAULT_STATE);
        }
    };

    handlePictureDrop = (accepted, rejected) => {
        if (accepted[0] instanceof Blob) {
            this.setState({ uploadingFile: accepted[0] });
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({ uploadingFileUrl: e.target.result });
            };
            reader.readAsDataURL(accepted[0]);
        }
    };

    handlePictureDelete = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ uploadingFileUrl: '' });
    };

    render() {
        const {
            report,
            items,
            authUsername,
        } = this.props;

        let content;

        if (items.length === 0) {
            content =
                <Error
                    title="No data"
                    subtitle="Add new message"
                />;
        } else {
            content = items.map((item) => (
                <ReportTalkMessage
                    item={item}
                    authUsername={authUsername}
                />
            ));
        }

        return (
            <Paper>
                <Subheader style={{ ...style.subHeader, ...style.relative }}>
                    {this.props.t('module.report.items')}
                </Subheader>

                <List style={dialogStyle.list} id="talk">
                    <ReportTalkMessage
                        item={{
                            user: report.user,
                            type: 'message',
                            response: report.title,
                            picture: report.picture,
                            created_at: report.created_at,
                        }}
                        authUsername={authUsername}
                    />
                    {content}
                </List>
                <Divider />
                <div style={{ padding: '20px' }} className="row">
                    <div
                        className="col-xs-12"
                        style={{
                            paddingLeft: '1em',
                            paddingRight: '1em',
                        }}
                    >
                        <TextField
                            hintText="message"
                            id="text-field-value"
                            value={this.state.value}
                            onChange={this.handleChange}
                            fullWidth={true}
                            multiLine={true}
                            style={dialogStyle.textfield}
                        />
                        <FloatingActionButton
                            style={{
                                display: 'inline-block',
                            }}
                            backgroundColor={blue600}
                            onClick={this.handleSendNewItem}
                        >
                            <SendIcon />
                        </FloatingActionButton>
                    </div>

                    <Dropzone
                        className="col-xs-12 col-sm-12 col-md-6"
                        ref={(node) => {
                            this.dropzoneRef = node;
                        }}
                        accept={supportedDropFiles}
                        onDrop={this.handlePictureDrop}
                        multiple={false}
                        disablePreview={true}
                        style={dialogStyle.dropzone}
                    >
                        {this.state.uploadingFileUrl ? (
                                <div>
                                    <button
                                        style={dialogStyle.closeButton}
                                        onClick={this.handlePictureDelete}
                                    >
                                        <ClearIcon style={dialogStyle.closeButtonIcon} />
                                    </button>
                                    <img
                                        style={dialogStyle.dialogBlockImg}
                                        src={this.state.uploadingFileUrl}
                                        alt="img"
                                    />
                                </div>
                            )
                            : (
                                <AddAPhotoIcon />
                            )
                        }
                    </Dropzone>

                    {
                        ModuleService.hasModule(this.props.app, ModuleService.PUSH)
                        && ModuleService.isPushModuleConfigured(this.props.app)
                        && (
                            <Checkbox
                                className="col-xs-12 col-sm-12 col-md-5"
                                id="push_entity"
                                style={style.formCheck}
                                label={this.props.t('module.push.push_entity')}
                                checked={this.state.push_entity}
                                onCheck={this.handlePushChange}
                            />
                        )
                    }
                </div>
            </Paper>
        );
    }
}

export default withTranslation(ReportTalk);



// WEBPACK FOOTER //
// src/components/report/ReportTalk/ReportTalk.js